import React, { useRef } from 'react';
import { Box, Button, ToggleButton, ToggleButtonGroup, TextField, Typography, Stack } from '@mui/material';
import { useApp } from '../stateMgmt/AppContext';
import { actions } from '../stateMgmt';

export function Toolbar() {

  const { showGrid, setShowGrid, showDimensions, setShowDimensions, ui, dispatch } = useApp();
  const fileInputRef = useRef(null);
  return (
    <Box
      sx={{
        p: 2,
        backgroundColor: 'background.paper',
        borderBottom: 1,
        borderColor: 'divider',
        display: 'flex',
        gap: 2,
        alignItems: 'center',
        alignSelf: 'start',
        flexWrap: 'wrap',
        margin: 'auto'
      }}
    >
      <ToggleButtonGroup
        value={showGrid ? 'grid' : null}
        exclusive
        onChange={() => setShowGrid(!showGrid)}
        size="small"
      >
        <ToggleButton value="grid">
          {showGrid ? 'הסתר רשת' : 'הצג רשת'}
        </ToggleButton>
      </ToggleButtonGroup>
      
      <ToggleButtonGroup
        value={showDimensions ? 'dimensions' : null}
        exclusive
        onChange={() => setShowDimensions(!showDimensions)}
        size="small"
      >
        <ToggleButton value="dimensions">
          {showDimensions ? 'הסתר מידות' : 'הצג מידות'}
        </ToggleButton>
      </ToggleButtonGroup>
      
      <Stack direction="row" spacing={1} alignItems="center">
        <Typography variant="body2">גודל רשת (מטרים):</Typography>
        <TextField
          type="number"
          size="small"
          inputProps={{
            min: 0.1,
            max: 2,
            step: 0.1,
            style: { width: '80px', textAlign: 'center' }
          }}
          value={ui?.gridSize || 0.5}
          onChange={(e) => dispatch({type: actions.SET_GRID_SIZE, payload: {gridSize: parseFloat(e.target.value)}})}
          sx={{ width: '100px' }}
        />
      </Stack>
      
      <Box sx={{ flex: 1 }} />
      
      <Button
        variant="contained"
        color="success"
        onClick={()=>{}}
        size="small"
      >
        ייצא בניין
      </Button>
      
      <Button
        variant="contained"
        color="warning"
        onClick={() => fileInputRef.current?.click()}
        size="small"
      >
        טען בניין
      </Button>
      
      <input
        ref={fileInputRef}
        type="file"
        accept=".json"
        onChange={(e) => {}}
        style={{ display: 'none' }}
      />
    </Box>
  );
}

